export const AUTH_KEY_STORAGE = 'gallium_auth_key'
export const AUTH_COOKIE_NAME = 'gallium_auth_key'
export const AUTH_COOKIE_MAX_AGE = 60 * 60 * 24 * 7

export const REFRESH_NAME = 'gallium_refresh'
export const REFRESH_MAX_AGE = 60 * 60 * 24 * 30

export const GUEST_CART_COOKIE = 'gallium-guest-cart'
export const DEALER_CART_COOKIE = 'gallium-dealer-cart'
export const CART_COOKIE = 'gallium-filters-cart'
export const CART_MAX_AGE = 60 * 60 * 24 * 7 // 7 days

export const CART_UPDATED_EVENT = 'cart:updated'
export const SAFE_TEXT_REGEX = /^[^<>]*$/ // blocks basic HTML/script injection
export const NAME_REGEX = /^[\p{Script=Latin}\p{Script=Arabic}\s'-]+$/u
export const ALPHANUMERIC_NAME_REGEX = /^[\p{Script=Latin}\p{Script=Arabic}\d\s'-]+$/u
export const ALPHANUMERIC_TEXT_REGEX = /^[\p{Script=Latin}\p{Script=Arabic}\d\s'.,&()/:-]+$/u
export const COMPANY_NAME_REGEX = /^[\p{Script=Latin}\p{Script=Arabic}\d\s'.,&()/:@-]+$/u
export const MAX_CONSECUTIVE_COMPANY_SPACES = 5
export const HAS_LETTER_REGEX = /[\p{L}]/u
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
export const PHONE_REGEX = /^[\d\s\-().]*$/
export const PHONE_DIGITS_ONLY_REGEX = /^\d+$/

export const MIN_COMPANY_LENGTH = 2
export const MAX_COMPANY_LENGTH = 80
export const MIN_MESSAGE_LENGTH = 10

export const MIN_SUBMIT_INTERVAL = 4000

export const DEVICE_ID = 'gallium-device-id'
export const LOCALE_KEY = 'gallium-locale'

export enum SEARCH {
  SMART = 'Smart Search',
  CROSS = 'Cross Reference',
  DIMENSION = 'Dimension Search',
}
export const SEARCH_TYPES = [SEARCH.SMART, SEARCH.CROSS, SEARCH.DIMENSION]

//Will not be accessible in client components
export const ENV = {
  PRIVATE: process.env.PAYLOAD_SECRET,
  APP_URL: process.env.NEXT_PUBLIC_APP_URL!,
  ERP_URL: process.env.ERP_URL! ?? process.env.ERP_LOGIN_URL!,
  BUCKET: {
    S3_ACCESS_KEY_ID: process.env.S3_ACCESS_KEY_ID!,
    S3_SECRET_ACCESS_KEY: process.env.S3_SECRET_ACCESS_KEY!,
    S3_REGION: process.env.S3_REGION!,
    S3_BUCKET: process.env.S3_BUCKET!,
  },
  OLD_ERP: {
    OLD_API_URL: process.env.OLD_API_URL ?? process.env.EXTERNAL_PRODUCTS_API!,
    OLD_API_AUTH: 'https://alshafaq.facts.ae/FQAPI/oauth/token',
    OLD_API_GEN_URL: 'https://alshafaq.facts.ae/FQAPI/api/proc',
    OLD_API_CLIENT_ID: process.env.OLD_API_CLIENT_ID!,
    OLD_API_CLIENT_SECRET: process.env.OLD_API_CLIENT_SECRET!,
    OLD_API_JOB_ID: process.env.OLD_API_JOB_ID!,
    OLD_API_GRANT_TYPE: process.env.OLD_API_GRANT_TYPE!,
  },
  NEWSLETTER: {
    NEWSLETTER_SMTP_SERVICE: process.env.NEWSLETTER_SMTP_SERVICE!,
    NEWSLETTER_SMTP_HOST: process.env.NEWSLETTER_SMTP_HOST!,
    NEWSLETTER_SMTP_PORT: process.env.NEWSLETTER_SMTP_PORT!,
    NEWSLETTER_SMTP_SECURE: process.env.NEWSLETTER_SMTP_SECURE!,
    NEWSLETTER_SMTP_USER: process.env.NEWSLETTER_SMTP_USER!,
    NEWSLETTER_SMTP_PASS: process.env.NEWSLETTER_SMTP_PASS!,
    NEWSLETTER_FROM: process.env.NEWSLETTER_FROM!,
  },
  TURNSTILE_SECRET_KEY: process.env.TURNSTILE_SECRET_KEY,
}

export const INDEX_DB_NAME = 'gallium-search-cache'
export const INDEX_DB_VERSION = 1
export const INDEX_DB_SEARCH_STORE = 'search-results'
export const INDEX_DB_CAROUSEL = 'carousel-results'

//Update this value to force user to delete all stored data
export const APP_VERSION = 'v1.1.11'
export const VERSION_STORAGE_KEY = 'gallium-app-version'

export const PRODUCT_PAGE_SIZE = 12

export const DIMENSION_FILTERS = [
  { value: 'outerDiameter', label: 'Outer Diameter' },
  { value: 'innerDiameter', label: 'Inner Diameter' },
  { value: 'overallHeight', label: 'Overall Height' },
  { value: 'dimensionA', label: 'Length' },
  { value: 'dimensionB', label: 'Breadth' },
  { value: 'dimensionH', label: 'Height' },
  { value: 'threadSize', label: 'Thread Size' },
  { value: 'centerTubeDiameter', label: 'Center Tube Diameter' },
  { value: 'gasketOD', label: 'Gasket Outer Diameter' },
  { value: 'gasketID', label: 'Gasket Inner Diameter' },
  { value: 'gasketThickness', label: 'Gasket Thickness' },
  { value: 'bypassValvePressure', label: 'Bypass Valve Pressure' },
  { value: 'antiDrainValve', label: 'Anti Drain Valve' },
  { value: 'micronRating', label: 'Micron Rating' },
  { value: 'dirtHoldingCapacity', label: 'Dirt Holding Capacity' },
  { value: 'burstPressure', label: 'Burst Pressure' },
  { value: 'filtrationEfficiency', label: 'Filtration Efficiency' },
  { value: 'ccmVsCleaningEfficiency', label: 'CCM Vs Cleaning Efficiency' },
]
